/**
 * These funcs have been copied and altered to work for BBC with atlaskit/renderer ^63.0.0
 * https://bitbucket.org/atlassian/atlassian-frontend/pull-requests/5326
 * They will most likely no longer be needed once we've upgraded renderer to a more
 * recent version which incorporates this functionality into the AK component.
 */

/**
 * Traverse through parent elements of element. Return element for which evaluate(element) returns
 * true. If topElement is reached before evaluate returns true, return false. Does not run evaluate
 * on topElement.
 * @param element Starting HTMLElement
 * @param topElement HTMLElement to end search at. evaluate is not called on this element
 * @param evaluate Function which returns true or false based on the given element. eg: Checks if
 * element has desired classname.
 */
export function findInTree(
  element: HTMLElement,
  topElement: HTMLElement,
  evaluate: (element: HTMLElement) => boolean
): boolean {
  if (element === topElement) {
    return false;
  }
  if (evaluate(element)) {
    return true;
  }
  if (!element.parentElement) {
    return false;
  }
  return findInTree(element.parentElement, topElement, evaluate);
}

/**
 * Check if an element is interactive/clicking on it shouldn't transition the
 * renderer to the editor in somewhere like the Jira description
 * @param element
 */
export function isInteractiveElement(
  element: HTMLElement | HTMLLinkElement
): boolean {
  if ('href' in element && element.href != null) {
    return true;
  }
  // for gifs/images/media in expanded and standard view
  const testId = element.getAttribute('data-testid');
  return testId === 'media-viewer-popup' || testId === 'media-file-card-view';
}
